import {
  SHOW_PHOTO_GALLERY,
  CLEAN_PHOTO_GALLERY,
  SET_PHOTO_INDEX,
} from '../actionTypes/photoGallery';

const initState = {
  show: false,
  photoList: [],
  currentIndex: 0,
};

export default (state = initState, action) => {
  switch (action.type) {
    case SHOW_PHOTO_GALLERY:
      return {
        show: true,
        photoList: action.photoList,
        currentIndex: action.currentIndex,
      };
    case CLEAN_PHOTO_GALLERY:
      return {
        show: false,
        photoList: [],
        currentIndex: 0,
      };
    case SET_PHOTO_INDEX:
      return {
        ...state,
        currentIndex: action.currentIndex,
      };
    default:
      return state;
  }
};
